import { render } from "./SelectedProductorTable.vue?vue&type=template&id=daacc0ee&ts=true"
import script from "./SelectedProductorTable.vue?vue&type=script&lang=ts"
export * from "./SelectedProductorTable.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__